// src/pages/ProjectExample.jsx
import './ProjectPage.css'; // separate CSS for project pages

import WarmStone_img2 from '../../assets/images/WarmStone_img2.png';
import WarmStone_img3 from '../../assets/images/WarmStone_img3.png';
import WarmStone_img5 from '../../assets/images/WarmStone_img5.png';
import WarmStone_img6 from '../../assets/images/WarmStone_img6.jpg';




function WarmStone() {
  return (
    <>


      <div className="project-page-wrapper">
        {/* Project title */}
        <h1 className="project-title">WarmStone: Create calm with personalized ceramic objects</h1>

        {/* Introduction text */}
        <p className="project-introduction">
        In a world full of constant digital stimuli, many people seek moments of calm and relaxation. WarmStone explores how handcrafted ceramic objects—small, tactile stones—can provide haptic comfort, ease stress, and bring mindfulness into everyday moments. 
        In workshops, participants create their own personal WarmStone: a warm, unique form that invites touch, sensation, and relaxation. Rather than relying on technology filled with alerts and notifications, this project focuses on touch and texture—physical experiences that help quiet the mind. 
        It is about feeling instead of looking, experiencing instead of scrolling.
        </p>

        {/* Image */}
        <div className="project-image">
          <img src={WarmStone_img6} alt="WarmStone_img6" />
        </div>

        {/* Details text */}
        <h2 className="section-title">Why WarmStone?</h2>
        <p className="project-details-text">
         Throughout history, people have used tangible objects and haptic sensations to self-soothe and reduce anxiety, from ancient practices like Prayer Beads and Worry Stones to modern-day fidgeting with buttons, stress balls, or jewelry. Prayer Beads, used in meditation, 
         provide comfort through repetitive touch, while Worry Stones, with thumb indentations, alleviate tension through rubbing. 
         In contemporary life, various fidget toys are designed to serve a similar purpose, helping to support stress relief. Extensive research has demonstrated the calming and therapeutic effects of tangible interaction with haptic objects. 

        </p>

        {/* Another image */}
        <div className="project-image">
           <img src={WarmStone_img2} alt="WarmStone_img2" />
        </div>

        {/* Further text */}
        <h2 className="section-title">How to create WarmStones?</h2>
        <p className="project-details-text">
          In this research we used ceramic crafting as a participatory design approach to explore people’s preferences and needs for tangible objects that provide personalized tactile experiences for stress relief and self-calming. 
          The study unfolded in five phases. First, participants created WarmStones during ceramic-making workshops. Next, the objects were fired, while we documented observations from the workshops and analyzed the resulting artifacts to identify common shapes, textures, and interaction patterns. 
          Afterward, participants received their fired WarmStones and incorporated them into daily life over a four-week in-situ period. Follow-up interviews were then conducted to gather insights into participants’ usage scenarios, real-world experiences, and how they engaged with the objects for tactile comfort. Finally, we performed a qualitative analysis of all collected data and synthesized the findings.
        </p>

          {/* Another image */}
        <div className="project-image">
         <img src={WarmStone_img3} alt="WarmStone_img3" />
        </div>


        {/* Further text */}
        <h2 className="section-title">What we learned</h2>
        <p className="project-details-text">
         Our findings reveal a design space for ceramic-based haptic comforting objects that emerges from the interplay of surface texture, object shape, and in-hand form. Rather than a single ideal design, participants’ experiences of comfort were highly individual but shaped by consistent patterns: softly matte surfaces were most often described as soothing, while subtly textured surfaces provided gentle stimulation for focus and engagement. 
         Rounded or plate-shaped forms were widely preferred, supporting slow, meditative handling, while palm- or pocket-sized objects with moderate weight offered sustained tactile use without fatigue. 
         The ceramic material’s solidity contributed grounding proprioceptive feedback, and alternative forms, such as rings or wearable shapes, enabled continuous low-effort touch. 
         Together, these results highlight that haptic comfort arises from the dynamic relationship between texture, shape, and in-hand interaction, demonstrating how participatory ceramic crafting can guide personalized design for stress regulation and self-calming.
        </p>

                  {/* Another image */}
        <div className="project-image">
         <img src={WarmStone_img5} alt="WarmStone_img5" />
        </div>

        <p className="project-details-text">
         Another key finding is that WarmStones naturally became part of participants’ everyday micro-interactions rather than being reserved for formal relaxation. 
         People used them while thinking at work, during meetings, after difficult conversations, on breaks, commuting, or preparing for bed. These haptic objects acted as subtle companions,
          supporting focus, grounding, and emotional self-regulation through recurring touch. Participants interacted with WarmStones in many ways: some explored them spontaneously, others used them in intentional self-calming rituals, while some engaged in brief transitional gestures after stressful moments. Unconscious fidgeting, like rubbing a thumb along the surface, helped redirect attention to bodily sensations or encourage positive mind wandering. For others, the stones served as sensory anchors or visual cues, where simply seeing one prompted a sense of calm or reminded them to slow down. 
         Overall, these everyday micro-interactions show how personalized tactile objects can support subtle, ongoing emotional regulation in daily life.
        </p>



        {/* Footer: financing and partners */}
        <div className="project-footer">
          <p><strong>Financed by:</strong> Seed funding, <a href="https://coeci.nl/" target="_blank" rel="noopener noreferrer">Centre of Expertise Creative Innovation (CoECI)</a></p>
          <p><strong>Project Partners:</strong>  <a href="https://jiechen.nl/" target="_blank" rel="noopener noreferrer">Studio JieChen</a> | <a href="https://boeyw.com/" target="_blank" rel="noopener noreferrer">Studio Boey</a></p>
        </div>
      </div>
    </>
  );
}

export default WarmStone;
